import {skipToken} from '@reduxjs/toolkit/query';
import {FormField} from 'platform/components';

import {isNil, isNotNil, sort} from 'ramda';
import {isNotNilOrEmpty} from 'ramda-adjunct';

import {getSafely, suffixTestId, TestIdProps} from 'shared/web';

import {usePriceReport} from '../../../hooks/usePriceReport';
import i18n from '../../../i18n/i18n';
import {useGetApiCountriesQuery, useGetTrimLevelsQuery} from '../../../store/catalogueApi';
import {useCreatePageContext} from './CreatePageContext';

export function TrimLevelField(props: TestIdProps) {
  const {requestData} = usePriceReport();
  const {
    control,
    values: {make, modelFamily, firstRegistrationOnYear},
  } = useCreatePageContext();
  const {data: apiCountries, isLoading: isApiCountriesLoading} = useGetApiCountriesQuery({
    format: 'iso3',
  });
  const {currentData: trimLevels, isFetching: isTrimLevelsLoading} = useGetTrimLevelsQuery(
    isNil(make) || isNil(modelFamily)
      ? skipToken
      : {
          modelFamily,
          make,
          country: isNotNil(requestData?.market)
            ? getSafely(apiCountries, requestData.market)
            : undefined,
          yearFrom: firstRegistrationOnYear ?? undefined,
          yearTo: firstRegistrationOnYear ?? undefined,
        }
  );
  const hasTrimLevels =
    !isApiCountriesLoading && !isTrimLevelsLoading && isNotNilOrEmpty(trimLevels?.trim_levels);
  const trimLevelsOptions = sort(
    (a, b) => {
      if (isNotNil(a.label) && isNotNil(b.label)) {
        return a.label.localeCompare(b.label);
      }
      return 0;
    },
    trimLevels?.trim_levels?.map((trimLevel) => ({
      label: trimLevel.label,
      value: trimLevel.const_key,
    })) ?? []
  );

  return (
    <FormField
      control={control}
      type="choice"
      name="trimLevel"
      label={i18n.t('page.create.labels.trimLevel')}
      options={trimLevelsOptions}
      isDisabled={!hasTrimLevels}
      menuInPortal
      data-testid={suffixTestId('form-trimLevel', props)}
    />
  );
}
